import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper scroll-wrapper" }
const _hoisted_2 = { class: "modal-title modal-title-hold" }
const _hoisted_3 = { class: "modal__title" }
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = {
  class: "content-block scroll-wrapper",
  ref: "contentBlockRef"
}
const _hoisted_6 = { class: "form" }
const _hoisted_7 = {
  class: "modal-content modal-content-hold",
  ref: "modalContainerRef"
}
const _hoisted_8 = { class: "form-fields form-fields-hold" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = {
  key: 0,
  class: "error"
}
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = {
  key: 0,
  class: "error"
}
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = {
  key: 0,
  class: "error"
}
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = {
  key: 0,
  class: "error"
}
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = {
  key: 0,
  class: "error"
}
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "error"
}
const _hoisted_22 = { class: "buttons-wr" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 1,
  class: "spinner-wr"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    "is-open": $setup.props.isOpen,
    onClose: $setup.onClose,
    classes: "request-hold-modal height-limited"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "button icon back",
            onClick: $setup.onBack,
            type: "button"
          }),
          _createElementVNode("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createTextVNode("Request a Hold", -1)),
            _createElementVNode("span", _hoisted_4, " (Lot " + _toDisplayString($props.lot.title) + ")", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "section-title" }, "Purchaser details", -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("label", null, [
                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "label" }, "First Name", -1)),
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass(["input-large", { 'input--error': $setup.v$.firstName.$error }]),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.firstName) = $event)),
                        placeholder: "First Name"
                      }, null, 2), [
                        [_vModelText, $setup.form.firstName]
                      ])
                    ]),
                    ($setup.v$.firstName.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString($setup.v$.firstName.required.$message), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", null, [
                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "label" }, "Last Name", -1)),
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass(["input-large", { 'input--error': $setup.v$.lastName.$error }]),
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.lastName) = $event)),
                        placeholder: "Last Name"
                      }, null, 2), [
                        [_vModelText, $setup.form.lastName]
                      ])
                    ]),
                    ($setup.v$.lastName.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString($setup.v$.lastName.required.$message), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", null, [
                      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "label" }, "Phone", -1)),
                      _createVNode($setup["Cleave"], {
                        class: _normalizeClass(["input input-large", { 'input--error': $setup.v$.phone.$error }]),
                        modelValue: $setup.form.phone,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.phone) = $event)),
                        options: $setup.phoneNumberOption($setup.form.phone),
                        placeholder: "0412 345 678"
                      }, null, 8, ["modelValue", "class", "options"])
                    ]),
                    ($setup.v$.phone.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString($setup.v$.phone.$errors[0]?.$message), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", null, [
                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "label" }, "Email", -1)),
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass(["input-large", { 'input--error': $setup.v$.email.$error }]),
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.email) = $event)),
                        placeholder: "Email"
                      }, null, 2), [
                        [_vModelText, $setup.form.email]
                      ])
                    ]),
                    ($setup.v$.email.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString($setup.v$.email.$errors[0]?.$message), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", null, [
                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "label" }, "Postcode", -1)),
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass(["input-large", { 'input--error': $setup.v$.postcode.$error }]),
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.postcode) = $event)),
                        placeholder: "e.g. 2000"
                      }, null, 2), [
                        [_vModelText, $setup.form.postcode]
                      ])
                    ]),
                    ($setup.v$.postcode.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString($setup.v$.postcode.$errors[0]?.$message), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", null, [
                      _cache[11] || (_cache[11] = _createElementVNode("span", { class: "label" }, "Owner-occupier / Investor", -1)),
                      _createElementVNode("div", null, [
                        _createVNode($setup["DropDown"], { class: "dropdown-container" }, {
                          control: _withCtx(() => [
                            _createElementVNode("label", {
                              class: "dropdown-button input-dropdown",
                              type: "button",
                              onClick: $setup.scrollToBottom
                            }, _toDisplayString($setup.form.holderType), 1)
                          ]),
                          dropdown: _withCtx(() => [
                            _createElementVNode("ul", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([$setup.HolderType.INVESTOR, $setup.HolderType.OWNER_OCCUPIER], (holder) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: holder,
                                  onClick: ($event: any) => ($setup.selectHolderType(holder)),
                                  class: _normalizeClass({ 'dropdown__item-active': holder === $setup.form.holderType })
                                }, _toDisplayString(holder), 11, _hoisted_20))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    ($setup.v$.holderType.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString($setup.v$.holderType.$errors[0]?.$message), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ], 512)
          ])
        ], 512),
        _createElementVNode("div", _hoisted_22, [
          (!$setup.disabled)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button large primary reserve",
                type: "submit",
                disabled: $setup.disabled,
                onClick: $setup.onReserve
              }, "Submit", 8, _hoisted_23))
            : (_openBlock(), _createElementBlock("div", _hoisted_24, [...(_cache[13] || (_cache[13] = [
                _createElementVNode("div", { class: "spinner spinner-small" }, null, -1)
              ]))])),
          _createElementVNode("button", {
            class: "button reserve",
            type: "button",
            onClick: $setup.onClose
          }, "Cancel")
        ])
      ])
    ]),
    _: 1
  }, 8, ["is-open"]))
}